import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 9.5, cy: 9.5, r: 9, stroke: "#676D7E" }));
export default SvgCircle;
